var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Form } from "../utils/Form";
var FormGroup = /** @class */ (function () {
    function FormGroup(formInput) {
        var _this = this;
        this.disabled = false;
        /** Function used to set the value of a control
         * @param key The controlName
         * @param value The value
         */
        this.set = function (key, value) {
            var _a;
            _this.form = __assign(__assign({}, _this.form), (_a = {}, _a[key] = value, _a));
            if (_this.changeFn)
                _this.changeFn(_this.getObjectValue());
        };
        /** Function used to get the value of a control
         * @param key The controlName
         * @returns The control value
         */
        this.get = function (key) { return _this.form[key]; };
        /** Function used to get the form value (JSON)
         * @returns The form value
        */
        this.getObjectValue = function () { return _this.form; };
        /** Function used to get the original form value
         * @returns The original form (FormControlsObject<T>)
         */
        this.getOriginal = function () { return _this.originalForm; };
        /** Function used to register to the form changes
         * @param fn The callback (argument: the form value)
         * @returns The FormGroup
         */
        this.onChange = function (fn) {
            _this.changeFn = fn;
            return _this;
        };
        /** Function used to check if the form is valid
         * @returns boolean
         */
        this.isValid = function () { return Object.keys(_this.form).every(function (k) { return Form.validateControl(__assign(__assign({}, _this.originalForm[k]), { value: _this.form[k] }), _this); }); };
        /** Function used to disable a control or the form
         * @param key The controlName (if not passed, disables the entire form)
         */
        this.disable = function (key) {
            var _a;
            if (!key)
                _this.disabled = true;
            else {
                _this.disabledControls = __assign(__assign({}, _this.disabledControls), (_a = {}, _a[key] = true, _a));
            }
        };
        /** Function used to enable a control or the form
         * @param key The controlName (if not passed, enables the entire form)
         */
        this.enable = function (key) {
            var _a;
            if (!key)
                _this.disabled = false;
            else {
                _this.disabledControls = __assign(__assign({}, _this.disabledControls), (_a = {}, _a[key] = false, _a));
            }
        };
        /** Function used to check if a control or the entire form are disabled
         * @param key The controlName (if not passed, checks the entire form)
         * @returns boolean
         */
        this.isDisabled = function (key) { var _a; return _this.disabled || ((_a = _this.disabledControls) === null || _a === void 0 ? void 0 : _a[key]); };
        /** Function used to toggle the 'required' flag on a control
         * @param key The controlName
         */
        this.toggleRequired = function (key) {
            var _a;
            _this.originalForm = __assign(__assign({}, _this.originalForm), (_a = {}, _a[key] = __assign(__assign({}, _this.originalForm[key]), { required: _this.originalForm[key] }), _a));
        };
        /** Function used to check if a control is required
         * @param key The controlName
         * @returns boolean
         */
        this.isRequired = function (control) { return _this.originalForm[control].required; };
        var obj = {};
        Object.keys(formInput).forEach(function (k) { var _a; return obj[k] = (_a = formInput[k].value) !== null && _a !== void 0 ? _a : null; });
        this.form = obj;
        this.originalForm = formInput;
    }
    return FormGroup;
}());
export { FormGroup };
